import React, { useEffect, useState, useContext, useMemo } from "react";
import { useTheme, alpha } from "@mui/material/styles";
import TreeView from "react-treeview";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";
import {
  Box,
  Button,
  Drawer,
  Typography,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  IconButton,
  Tooltip,
  Dialog,
  useMediaQuery,
} from "@mui/material";
import { SidebarContext } from "../Sidebar/SidebarProvider";
import {
  FolderOpen as FolderOpenIcon,
  AccountTreeOutlined as AccountTreeOutlinedIcon,
  DryCleaningOutlined as DryCleaningOutlinedIcon,
  DesignServicesOutlined as DesignServicesOutlinedIcon,
  AddCircleOutlineOutlined as AddCircleOutlineOutlinedIcon,
  Add as AddIcon,
  DeleteOutline as DeleteOutlinedIcon,
  ViewWeekOutlined as ViewWeekOutlinedIcon,
} from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import {
  getProducts,
  addProduct,
  updateProduct,
  getDesigners,
  deleteProduct,
} from "../../api/Design/productApi";
import { getTemporadas } from "../../api/Temporadas/temporadaApi";
import { getModelosTipo } from "../../api/Design/modelosTipoApi";
import { getSubgrupos } from "../../api/Subgrupos/subgrupoApi";

import { getMarcas } from "../../api/Marcas/marcaApi";
import { getUserById } from "../../api/User/userApi";
import { canUserAccessProductTree } from "../../utils/userPermissionsUtils";
import {
  canEnrollNmlSuzhou,
  shouldPromptNmlEnroll,
} from "../../utils/nmlSuzhouCatalog";
import NmlEnrollDialog from "../NmlSuzhou/NmlEnrollDialog";
/* import { getProductosMuestras } from "../../api/Design/treeApi"; */
import NASFileManager from "./FileManager";
import {
  addMuestra,
  getProductMuestras,
  getMuestrasTipo,
  getMuestrasEstado,
  getMuestrasTallas,
  getMuestrasColores,
  getMuestrasProveedores,
  addEscandallo,
  getEscandalloGrupos,
  getEscandalloSubgruposMuestras,
  getProveedores,
  deleteMuestra,
} from "../../api/Muestras/muestraApi";
import FileUploader from "./FileUploader";
/* import DrawerMuestra from "../../components/Muestras/DrawerMuestra"; */

import DrawerMuestraV2 from "../../components/Muestras/Drawer/DrawerMuestraV2";

import "react-treeview/react-treeview.css";
import "../../css/productTree.css";
const ProductTree = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { contentMargin } = useContext(SidebarContext);
  const [products, setProducts] = useState([]);
  const [designers, setDesigners] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [modelosTipo, setModelosTipo] = useState([]);
  const [temporadas, setTemporadas] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [subgrupos, setSubgrupos] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [muestraDrawerOpen, setMuestraDrawerOpen] = useState(false);
  const [sortBy, setSortBy] = useState("nombre");
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedNodes, setExpandedNodes] = useState({
    temporada: {},
    marca: {},
    designer: {},
    product: {},
  });
  const [tiposMuestra, setTiposMuestra] = useState([]);
  const [tiposEstado, setTiposEstado] = useState([]);
  const [tiposTallas, setTiposTallas] = useState([]);
  const [tiposColores, setTiposColores] = useState([]);
  const [tiposProveedores, setTiposProveedores] = useState([]);

  const [escandalloGrupos, setEscandalloGrupos] = useState([]);
  const [escandalloSubgrupos, setEscandalloSubgrupos] = useState([]);
  const [fileManagerOpen, setFileManagerOpen] = useState(false);
  const [productSamples, setProductSamples] = useState({});

  const [userCanCreateSample, setUserCanCreateSample] = useState(false);
  const [hasProductTreeAccess, setHasProductTreeAccess] = useState(false);

  const [loadingSamples, setLoadingSamples] = useState({});
  const [mobileDetailView, setMobileDetailView] = useState(false);

  // 1. Estado para el diálogo y el producto a borrar
  const [openDeleteProductDialog, setOpenDeleteProductDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const [openNombreDuplicadoDialog, setOpenNombreDuplicadoDialog] =
    useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [nmlEnrollProduct, setNmlEnrollProduct] = useState(null);
  const canEnrollNml = canEnrollNmlSuzhou(currentUser || {});

  const toggleFileManager = () => {
    setFileManagerOpen(!fileManagerOpen);
  };

  const [newProduct, setNewProduct] = useState({
    tipo_prenda: "",
    main_fabric: "",
    diseñador: "",
    nombre: "",
    /* nombreCliente: "", */
    ID_Temporada: "",
    ID_MARCA: "",
  });
  const [newMuestra, setNewMuestra] = useState({
    MUESTRA: "",
    ID_ESTADO: "",
    ID_TIPO_MUESTRA: "",
    ID_TALLA_BASE: "",
    ID_COLOR_BASE: "",
    FECHA_PETICION: null,
    FECHA_PREVISTA: null,
    FECHA_RECEPCION: null,
    NOTAS: "",
    PROVEEDOR: "",
    ID_RESPONSABLE_SUPPLIER: null,
    PRIORIDAD: null,
    FECHA_PREVISTA_FABRICA: null,
    CALIDAD_NOMBRE: "",
    CALIDAD_ESTADO: null,
    PRINT_NOMBRE: "",
    PRINT_ESTADO: null,
    ID_PRODUCTO: "",
    ESCANDALLO_GRUPOS: "",
    ESCANDALLO_SUBGRUPO: "",
    UN: "",
    COSTE: "",
  });
  const [escandallos, setEscandallos] = useState([{}]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requestedProductId = Number(searchParams.get("productId"));
  const requestedMuestraId = Number(searchParams.get("muestraId"));

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/login");
          return;
        }

        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }

        const user = await getUserById(decodedToken.userId);
        const canAccess = canUserAccessProductTree(user);
        if (!canAccess) {
          navigate("/muestras", { replace: true });
          return;
        }
        if (cancelled) return;

        setHasProductTreeAccess(true);
        setCurrentUser(user);
        setUserCanCreateSample(!!decodedToken?.PermisoCreateSample);

        const [
          productsData,
          designersData,
          temporadasData,
          modelosTipoData,
          subgruposData,
        ] = await Promise.all([
          getProducts(),
          getDesigners(),
          getTemporadas(),
          getModelosTipo(),
          getSubgrupos(),
        ]);
        if (cancelled) return;

        setProducts(productsData || []);
        setDesigners(designersData || []);
        setTemporadas(temporadasData || []);
        setModelosTipo(modelosTipoData || []);
        setSubgrupos(subgruposData || []);
      } catch (error) {
        console.error("Error inicializando ProductTree:", error);
        navigate("/login");
      }
    };

    initialize();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  /* fetchMarcas */
  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const marcasData = await getMarcas();
        setMarcas(marcasData || []);
      } catch (error) {
        console.error("Error fetching marcas:", error);
      }
    };
    fetchMarcas();
  }, []);

  /* fetchTiposMuestra */
  useEffect(() => {
    const fetchTiposMuestra = async () => {
      const tipos = await getMuestrasTipo();
      setTiposMuestra(tipos);
    };
    fetchTiposMuestra();
  }, []);

  /* fetchTiposEstado */
  useEffect(() => {
    const fetchTiposEstado = async () => {
      const tipos = await getMuestrasEstado();
      setTiposEstado(tipos);
    };
    fetchTiposEstado();
  }, []);

  /* fetchTiposTallas */
  useEffect(() => {
    const fetchTiposTallas = async () => {
      const tipos = await getMuestrasTallas();
      setTiposTallas(tipos);
    };
    fetchTiposTallas();
  }, []);

  /* fetchTiposColores */
  useEffect(() => {
    const fetchTiposColores = async () => {
      const tipos = await getMuestrasColores();
      setTiposColores(tipos);
    };
    fetchTiposColores();
  }, []);

  /* fetchTiposProveedores */
  useEffect(() => {
    const fetchTiposProveedores = async () => {
      const tipos = await getMuestrasProveedores();
      setTiposProveedores(tipos);
    };
    fetchTiposProveedores();
  }, []);

  /* fetchProveedores */
  useEffect(() => {
    const fetchProveedores = async () => {
      try {
        const proveedores = await getProveedores();
        setTiposProveedores(proveedores);
      } catch (error) {
        console.error("Error al obtener proveedores:", error);
      }
    };
    fetchProveedores();
  }, []);

  /* fetchEscandalloGrupos */
  useEffect(() => {
    const fetchEscandalloGrupos = async () => {
      try {
        const grupos = await getEscandalloGrupos();
        setEscandalloGrupos(grupos);
      } catch (error) {
        console.error("Error fetching Escandallo Grupos:", error);
      }
    };
    fetchEscandalloGrupos();
  }, []);

  /* fetchSubgrupos */
  useEffect(() => {
    const fetchSubgrupos = async () => {
      if (newMuestra.ESCANDALLO_GRUPOS) {
        const subgrupos = await getEscandalloSubgruposMuestras(
          newMuestra.ESCANDALLO_GRUPOS,
        );
        setEscandalloSubgrupos(subgrupos);
      }
    };
    fetchSubgrupos();
  }, [newMuestra.ESCANDALLO_GRUPOS]);

  const handleGrupoChange = async (e) => {
    const selectedGrupoId = e.target.value;
    setNewMuestra((prev) => ({ ...prev, ESCANDALLO_GRUPOS: selectedGrupoId }));
    const subgrupos = await getEscandalloSubgruposMuestras(selectedGrupoId);
    setEscandalloSubgrupos(subgrupos);
  };

  const refreshData = async () => {
    try {
      const productsData = await getProducts();
      setProducts(productsData);

      // 🔥 Resetea muestras cacheadas
      setProductSamples({});
      setLoadingSamples({});
    } catch (error) {
      console.error("Error al refrescar los datos:", error);
    }
  };

  const getDesignerName = (designerId) => {
    const designer = designers.find((d) => d.id === parseInt(designerId));
    return designer ? designer.username : "N/A";
  };

  const getTipoPrendaName = (abbrTipoPrenda) => {
    const tipoPrenda = modelosTipo.find(
      (m) => m.ABREVIATURA === abbrTipoPrenda,
    );
    return tipoPrenda ? tipoPrenda.TIPO : "N/A";
  };

  const getSubgrupoName = (mainFabricId) => {
    const subgrupo = subgrupos.find(
      (s) => s.ID_SUBGRUPO === parseInt(mainFabricId),
    );
    return subgrupo ? subgrupo.SUBGRUPO : "N/A";
  };

  const handleAddProductClick = () => {
    setNewProduct({
      tipo_prenda: "",
      main_fabric: "",
      diseñador: "",
      nombre: "",
      /* nombreCliente: "", */
      ID_Temporada: "",
      ID_MARCA: "",
    });
    setDrawerOpen(true);
  };

  const handleEditProductClick = (product) => {
    setNewProduct({
      tipo_prenda: product.tipo_prenda,
      main_fabric: product.main_fabric,
      ID_SUBGRUPO: product.main_fabric,
      diseñador: product.diseñador,
      nombre: product.nombre,
      ID_Temporada: product.ID_Temporadas,
      ID_MARCA: product.ID_MARCA,
      id: product.id, // importante para distinguir si es edición
    });
    setDrawerOpen(true);
  };

  // Abrir el diálogo de eliminación
  const handleDeleteProduct = (product) => {
    const samplesFromCache = productSamples[product.id] || [];
    const samplesFromProduct = product.muestras || [];
    const samplesForProduct =
      samplesFromCache.length > 0 ? samplesFromCache : samplesFromProduct;

    const hasSamples = samplesForProduct.length > 0;
    const hasFiles = !!productHasFiles[product.id];

    if (hasSamples || hasFiles) {
      alert(
        "No puedes eliminar este diseño porque tiene muestras o archivos asociados.",
      );
      return;
    }

    setProductToDelete(product);
    setOpenDeleteProductDialog(true);
  };

  // CONFIRMA LA ELIMINACIÓN DE DISEÑOS
  const confirmDeleteProduct = async () => {
    if (!productToDelete) return;

    try {
      await deleteProduct(productToDelete.id);

      setProducts((prev) => prev.filter((p) => p.id !== productToDelete.id));

      if (selectedProductId === productToDelete.id) {
        setSelectedProduct(null);
        setSelectedProductId(null);
      }

      setProductSamples((prev) => {
        const copy = { ...prev };
        delete copy[productToDelete.id];
        return copy;
      });

      setProductHasFiles((prev) => {
        const copy = { ...prev };
        delete copy[productToDelete.id];
        return copy;
      });
    } catch (err) {
      console.error("Error eliminando producto:", err);

      const msgBackend = err?.response?.data?.message;
      alert(
        msgBackend ||
          "No se ha podido eliminar el diseño. Es posible que tenga muestras o archivos asociados.",
      );
    } finally {
      setOpenDeleteProductDialog(false);
      setProductToDelete(null);
    }
  };

  const cancelDeleteProduct = () => {
    setOpenDeleteProductDialog(false);
    setProductToDelete(null);
  };

  // 3. Saber si el diseño tiene archivos/fotos
  const [productHasFiles, setProductHasFiles] = useState({}); // { [productId]: boolean }

  const handleFilesStatusChange = (productId, hasFiles) => {
    setProductHasFiles((prev) => ({
      ...prev,
      [productId]: hasFiles,
    }));
  };

  /* va pintando el nombre del producto dinamicamente */
  useEffect(() => {
    const designerAbbr =
      designers.find((d) => d.id === newProduct.diseñador)?.abreviatura ||
      "DES";
    const temporadaAbbr =
      temporadas.find((t) => t.ID_TEMPORADA === newProduct.ID_Temporada)
        ?.ABREVIATURA || "TEMP";
    /* const modeloAbbr =
      modelosTipo.find((m) => m.ABREVIATURA === newProduct.tipo_prenda)
        ?.ABREVIATURA || "MOD"; */
    const modelo = modelosTipo.find(
      (m) => m.ID_TIPO === parseInt(newProduct.tipo_prenda),
    );
    const modeloAbbr = modelo?.ABREVIATURA || "MOD";
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    // Genera el nombre
    const generatedName = `${designerAbbr}${temporadaAbbr}${modeloAbbr}${randomDigits}`;
    // Solo actualiza si el usuario no ha modificado el nombre
    if (!newProduct.nombre || newProduct.nombre.startsWith("DES")) {
      setNewProduct((prev) => ({ ...prev, nombre: generatedName }));
    }
  }, [newProduct.diseñador, newProduct.ID_Temporada, newProduct.tipo_prenda]);

  const handleSaveProduct = async () => {
    // Generar el nombre dinámicamente al guardar
    const designerAbbr =
      designers.find((d) => d.id === newProduct.diseñador)?.abreviatura ||
      "DES";
    const temporadaAbbr =
      temporadas.find((t) => t.ID_TEMPORADA === newProduct.ID_Temporada)
        ?.ABREVIATURA || "TEMP";
    /* const modeloAbbr =
      modelosTipo.find((m) => m.ABREVIATURA === newProduct.tipo_prenda)
        ?.ABREVIATURA || "MOD"; */
    const modelo = modelosTipo.find(
      (m) => m.ID_TIPO === parseInt(newProduct.tipo_prenda),
    );
    const modeloAbbr = modelo?.ABREVIATURA || "MOD";
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    // Genera el nombre final
    const generatedName = `${designerAbbr}${temporadaAbbr}${modeloAbbr}${randomDigits}`;
    // Usa el nombre generado si el usuario no lo cambió
    const nombreFinal =
      newProduct.nombre === "" || newProduct.nombre === generatedName
        ? generatedName
        : newProduct.nombre;

    // ⚠️ 1. Verifica si el nombre ya existe (excepto si es edición del mismo)
    const productosExistentes = await getProducts();
    const nombreDuplicado = productosExistentes.find(
      (p) =>
        p.nombre === nombreFinal && (!newProduct.id || p.id !== newProduct.id), // Evita conflicto con sí mismo en edición
    );

    if (nombreDuplicado) {
      setOpenNombreDuplicadoDialog(true);
      return;
    }

    const updatedProduct = {
      ...newProduct,
      nombre: nombreFinal,
      /* nombreCliente: newProduct.nombreCliente, */
      ID_Temporadas: newProduct.ID_Temporada,
      main_fabric: newProduct.ID_SUBGRUPO,
      ID_MARCA: newProduct.ID_MARCA,
    };

    try {
      let createdPayload = null;
      if (newProduct.id) {
        // 🔁 Modo edición
        await updateProduct(updatedProduct.id, updatedProduct); // ✅ pasa id como primer parámetro
      } else {
        // 🆕 Modo creación
        createdPayload = await addProduct(updatedProduct);
      }

      setDrawerOpen(false);
      setNewProduct({
        tipo_prenda: "",
        main_fabric: "",
        diseñador: "",
        nombre: "",
        ID_Temporada: "",
        ID_TIPO: "",
        ID_SUBGRUPO: "",
        ID_MARCA: "",
      });

      const updatedProducts = await getProducts();
      setProducts(updatedProducts);

      // 🔥 Añadir esto
      const productoActualizado = updatedProducts.find(
        (p) => p.id === updatedProduct.id,
      );
      if (productoActualizado) {
        setSelectedProduct(productoActualizado);
      }

      if (
        !newProduct.id &&
        canEnrollNmlSuzhou(currentUser || {}) &&
        shouldPromptNmlEnroll(nombreFinal)
      ) {
        const createdProduct =
          createdPayload?.producto ||
          updatedProducts.find((p) => p.nombre === nombreFinal);
        if (createdProduct?.id) {
          setNmlEnrollProduct(createdProduct);
        }
      }
    } catch (error) {
      console.error("Error al guardar el producto:", error);
    }
  };

  const handleAddMuestraClick = (product) => {
    setSelectedProduct(product);
    // Encuentra la abreviatura del tipo de muestra si está seleccionada
    const tipoMuestra = tiposMuestra.find(
      (tipo) => tipo.ID_TIPO === newMuestra.ID_TIPO_MUESTRA,
    );
    const abreviaturaTipoMuestra = tipoMuestra ? tipoMuestra.ABREVIATURA : "";
    // Restablece el estado de newMuestra para asegurar que el drawer se abre en blanco y con el nombre generado
    setNewMuestra({
      MUESTRA: `SAMP-${Math.random()
        .toString(36)
        .substring(2, 7)
        .toUpperCase()}-${abreviaturaTipoMuestra}`,
      ID_ESTADO: 1,
      ID_Marca: product?.ID_MARCA || "", // 👈 hereda Brand del producto
      ID_TIPO_MUESTRA: "",
      ID_TALLA_BASE: "",
      ID_COLOR_BASE: "",
      FECHA_PETICION: null,
      FECHA_PREVISTA: null,
      FECHA_RECEPCION: null,
      NOTAS: "",
      PROVEEDOR: "",
      ID_RESPONSABLE_SUPPLIER: null,
      PRIORIDAD: null,
      FECHA_PREVISTA_FABRICA: null,
      CALIDAD_NOMBRE: "",
      CALIDAD_ESTADO: null,
      PRINT_NOMBRE: "",
      PRINT_ESTADO: null,
      ID_PRODUCTO: product ? product.id : "",
      ESCANDALLO_GRUPOS: "",
      ESCANDALLO_SUBGRUPO: "",
      UN: "",
      COSTE: "",
    });
    // Restablece los escandallos a un estado limpio (array vacío o un objeto vacío, según la lógica)
    setEscandallos([{}]);
    setMuestraDrawerOpen(true);
  };

  const handleAddMuestraLocally = (productId, newMuestra) => {
    // Actualiza las muestras en `products`
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === productId
          ? {
              ...product,
              muestras: [...(product.muestras || []), newMuestra],
            }
          : product,
      ),
    );
    // Actualiza las muestras en `productSamples`
    setProductSamples((prevSamples) => ({
      ...prevSamples,
      [productId]: [...(prevSamples[productId] || []), newMuestra],
    }));
    // Expande el nodo del producto afectado
    setExpandedNodes((prev) => ({
      ...prev,
      product: {
        ...prev.product,
        [productId]: true, // Expande el nodo del producto afectado
      },
    }));
  };

  const handleDeleteMuestraFromTree = (idMuestra, productId) => {
    // 1. Actualiza products
    setProducts((prev) =>
      prev.map((p) =>
        p.id === productId
          ? {
              ...p,
              muestras: p.muestras?.filter((m) => m.ID_MUESTRA !== idMuestra),
            }
          : p,
      ),
    );

    // 2. Actualiza productSamples
    setProductSamples((prev) => ({
      ...prev,
      [productId]: (prev[productId] || []).filter(
        (m) => m.ID_MUESTRA !== idMuestra,
      ),
    }));

    // 3. Si está seleccionada esa muestra → limpiar
    if (selectedProductId === productId) {
      setSelectedProduct((prev) =>
        prev
          ? {
              ...prev,
              muestras: prev.muestras?.filter(
                (m) => m.ID_MUESTRA !== idMuestra,
              ),
            }
          : null,
      );
    }

    // 4. Refrescar vista árbol
  };

  const handleSaveMuestra = async () => {
    try {
      const savedMuestra = await addMuestra(newMuestra);
      await addEscandallo({
        ID_MUESTRA: savedMuestra.ID_MUESTRA,
        Proveedor: newMuestra.PROVEEDOR,
        ESCANDALLO_GRUPOS: newMuestra.ESCANDALLO_GRUPOS,
        ESCANDALLO_SUBGRUPO: newMuestra.ESCANDALLO_SUBGRUPO,
        Un: newMuestra.UN,
        Coste: newMuestra.COSTE,
      });
      // Actualizar localmente el árbol
      if (savedMuestra) {
        handleAddMuestraLocally(savedMuestra.ID_PRODUCTO, savedMuestra);
      }

      setMuestraDrawerOpen(false);
    } catch (error) {
      console.error("Error al guardar la muestra:", error);
      alert("Error al guardar la muestra. Por favor, inténtalo de nuevo.");
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  // ⏳ Debounce de búsqueda
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 900);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const filterProducts = (items = []) => {
    if (!debouncedSearch || debouncedSearch.length < 3) {
      return { filtered: items, newExpanded: {} };
    }

    const lowerSearch = debouncedSearch.toLowerCase();
    const newExpanded = { temporada: {}, marca: {}, designer: {}, product: {} };

    const filtered = items.filter((item) => {
      const temporada =
        temporadas.find((t) => t.ID_TEMPORADA === item.ID_Temporadas)
          ?.TEMPORADA || "";
      const marca =
        marcas.find((m) => m.ID_MARCA === item.ID_MARCA)?.MARCA || "";
      const designerName = getDesignerName(item.diseñador);
      const mainFabric = getSubgrupoName(item.main_fabric);
      const tipoPrenda = getTipoPrendaName(item.tipo_prenda);
      const muestrasFromCache = productSamples[item.id] || [];
      const muestrasFromProduct = item.muestras || [];
      const muestras =
        muestrasFromCache.length > 0 ? muestrasFromCache : muestrasFromProduct;

      const match =
        item.nombre.toLowerCase().includes(lowerSearch) ||
        tipoPrenda.toLowerCase().includes(lowerSearch) ||
        mainFabric.toLowerCase().includes(lowerSearch) ||
        designerName.toLowerCase().includes(lowerSearch) ||
        temporada.toLowerCase().includes(lowerSearch) ||
        marca.toLowerCase().includes(lowerSearch) ||
        muestras.some(
          (m) =>
            m.MUESTRA?.toLowerCase().includes(lowerSearch) ||
            m.NombreCliente?.toLowerCase().includes(lowerSearch),
        );

      if (match) {
        newExpanded.temporada[item.ID_Temporadas] = true;
        newExpanded.marca[item.ID_MARCA] = true;
        newExpanded.designer[item.diseñador] = true;
        newExpanded.product[item.id] = true;
      }

      return match;
    });

    return { filtered, newExpanded };
  };

  const groupByField = (items = [], field) => {
    if (!Array.isArray(items)) return {}; // 🚫 Evita el error
    return items.reduce((group, item) => {
      const key = item?.[field] ?? "Sin Clasificar"; // Maneja valores nulos o undefined
      if (!group[key]) group[key] = [];
      group[key].push(item);
      return group;
    }, {});
  };

  const sortAlphabetically = (items, field) => {
    return [...items].sort((a, b) => {
      const aValue = a[field]?.toString().toLowerCase() || "";
      const bValue = b[field]?.toString().toLowerCase() || "";
      return aValue.localeCompare(bValue);
    });
  };

  const toggleNode = async (nodeId, parentLevel, product = null) => {
    setExpandedNodes((prev) => {
      const newNodes = { ...prev };
      if (!newNodes[parentLevel]) newNodes[parentLevel] = {};
      newNodes[parentLevel][nodeId] = !newNodes[parentLevel][nodeId];
      return newNodes;
    });

    if (parentLevel === "product" && product) {
      setSelectedProduct(product);
      setSelectedProductId(product.id);
      setSelectedSampleId(null);
      if (isMobile) setMobileDetailView(true);

      if (!(product.id in productSamples)) {
        try {
          setLoadingSamples((prev) => ({ ...prev, [product.id]: true }));

          const muestras = await getProductMuestras(product.id);

          setProductSamples((prev) => ({
            ...prev,
            [product.id]: muestras,
          }));
        } catch (err) {
          console.error("Error cargando muestras:", err);
        } finally {
          setLoadingSamples((prev) => ({ ...prev, [product.id]: false }));
        }
      }
    } else {
      setSelectedProduct(null);
      setSelectedProductId(null);
      setSelectedSampleId(null);
      if (isMobile) setMobileDetailView(false);
    }
  };

  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedSampleId, setSelectedSampleId] = useState(null);

  useEffect(() => {
    if (
      !Number.isFinite(requestedProductId) ||
      !Number.isFinite(requestedMuestraId) ||
      products.length === 0
    ) {
      return undefined;
    }

    const product = products.find(
      (item) => Number(item.id) === requestedProductId,
    );
    if (!product) return undefined;

    let cancelled = false;
    setSearchTerm("");
    setDebouncedSearch("");
    setSelectedProduct(product);
    setSelectedProductId(product.id);
    setSelectedSampleId(requestedMuestraId);
    if (isMobile) setMobileDetailView(true);
    setExpandedNodes((prev) => ({
      temporada: {
        ...prev.temporada,
        [product.ID_Temporadas]: true,
      },
      marca: {
        ...prev.marca,
        [product.ID_MARCA]: true,
      },
      designer: {
        ...prev.designer,
        [product.diseñador]: true,
      },
      product: {
        ...prev.product,
        [product.id]: true,
      },
    }));

    const loadRequestedSample = async () => {
      setLoadingSamples((prev) => ({ ...prev, [product.id]: true }));
      try {
        const muestras = await getProductMuestras(product.id);
        if (cancelled) return;
        setProductSamples((prev) => ({
          ...prev,
          [product.id]: muestras || [],
        }));
      } catch (error) {
        console.error("Error abriendo muestra desde el listado:", error);
      } finally {
        if (!cancelled) {
          setLoadingSamples((prev) => ({ ...prev, [product.id]: false }));
        }
      }
    };

    loadRequestedSample();
    return () => {
      cancelled = true;
    };
  }, [isMobile, products, requestedMuestraId, requestedProductId]);

  const renderTreeItems = () => {
    const groupedByTemporada = groupByField(filtered, "ID_Temporadas");
    return Object.keys(groupedByTemporada).map((temporadaKey) => {
      const temporada = temporadas.find(
        (temp) => temp.ID_TEMPORADA === parseInt(temporadaKey, 10),
      );
      const temporadaLabel = temporada ? temporada.TEMPORADA : "Sin Temporada";
      return (
        <TreeView
          key={`temporada-${temporadaKey}`}
          nodeLabel={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: ".5em 0",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: ".9em",
              }}
              onClick={() => toggleNode(temporadaKey, "temporada")}
            >
              <AccountTreeOutlinedIcon
                sx={{ color: "#90b2b7", marginRight: ".5em" }}
              />
              {temporadaLabel}
            </div>
          }
          collapsed={!expandedNodes.temporada?.[temporadaKey]}
        >
          {renderMarcas(
            sortAlphabetically(groupedByTemporada[temporadaKey], "ID_MARCA"),
            temporadaKey,
          )}
        </TreeView>
      );
    });
  };
  const renderMarcas = (productsByTemporada, temporadaKey) => {
    const groupedByMarca = groupByField(productsByTemporada, "ID_MARCA");

    return Object.keys(groupedByMarca)
      .sort((a, b) => {
        const marcaA =
          marcas.find((m) => m.ID_MARCA === parseInt(a, 10))?.MARCA || "";
        const marcaB =
          marcas.find((m) => m.ID_MARCA === parseInt(b, 10))?.MARCA || "";
        return marcaA.localeCompare(marcaB);
      })
      .map((marcaKey) => {
        const marca = marcas.find((m) => m.ID_MARCA === parseInt(marcaKey, 10));
        const marcaLabel = marca ? marca.MARCA : "Sin Marca";

        return (
          <TreeView
            key={`marca-${marcaKey}`}
            nodeLabel={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: ".9em",
                  padding: ".5em 0",
                }}
                onClick={() => toggleNode(marcaKey, "marca")}
              >
                <FolderOpenIcon
                  sx={{ color: "#90b2b7", marginRight: ".5em" }}
                />
                {marcaLabel}
              </div>
            }
            collapsed={!expandedNodes.marca?.[marcaKey]}
          >
            {renderDesigners(
              sortAlphabetically(groupedByMarca[marcaKey], "diseñador"),
              marcaKey,
            )}
          </TreeView>
        );
      });
  };
  const renderDesigners = (productsByMarca, marcaKey) => {
    const groupedByDesigner = groupByField(productsByMarca, "diseñador");

    return Object.keys(groupedByDesigner)
      .sort((a, b) => {
        const designerA = getDesignerName(a) || "";
        const designerB = getDesignerName(b) || "";
        return designerA.localeCompare(designerB);
      })
      .map((designerKey) => {
        const designerLabel = getDesignerName(designerKey) || "Sin Diseñador";
        return (
          <TreeView
            key={`designer-${designerKey}`}
            nodeLabel={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  fontWeight: 700,
                  fontSize: ".9em",
                  padding: ".5em 0",
                }}
                onClick={() => toggleNode(designerKey, "designer")}
              >
                <DesignServicesOutlinedIcon
                  sx={{ color: "#90b2b7", marginRight: ".5em" }}
                />
                {designerLabel}
              </div>
            }
            collapsed={!expandedNodes.designer?.[designerKey]}
          >
            {renderProducts(
              sortAlphabetically(groupedByDesigner[designerKey], "nombre"),
              designerKey,
            )}
          </TreeView>
        );
      });
  };
  const renderProducts = (productsByDesigner, designerKey) => {
    const sortedProducts = sortAlphabetically(productsByDesigner, "nombre");

    return sortedProducts.map((product) => {
      // ❌ Antes: const samplesFromCache = productSamples[product.id] || [];
      // ✅ Ahora: distinguimos entre "no cargado" y "array vacío"
      const samplesFromCache = productSamples[product.id];
      const samplesKnown = Array.isArray(samplesFromCache);
      const hasSamples = samplesKnown && samplesFromCache.length > 0;

      const filesKnown = Object.prototype.hasOwnProperty.call(
        productHasFiles,
        product.id,
      );
      const hasFiles = filesKnown && !!productHasFiles[product.id];

      const canDelete = samplesKnown && filesKnown && !hasSamples && !hasFiles;

      return (
        <TreeView
          key={`product-${product.id}`}
          nodeLabel={
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: ".9em",
                width: isMobile ? "100%" : "98%",
                justifyContent: "space-between",
                background:
                  selectedProductId === product.id
                    ? theme.palette.primary.main
                    : "transparent",
                color:
                  selectedProductId === product.id
                    ? theme.palette.primary.contrastText
                    : theme.palette.text.secondary,
                padding: ".5em",
                borderRadius: selectedProductId === product.id ? "4px" : "",
                fontWeight: "600",
              }}
              onClick={() => toggleNode(product.id, "product", product)}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  justifyContent: "space-between",
                }}
              >
                <FolderOpenIcon
                  sx={{
                    color:
                      selectedProductId === product.id ? "#fff" : "#90b2b7",
                    marginRight: ".5em",
                  }}
                />
                <span
                  title={product.nombre}
                  style={{
                    color:
                      selectedProductId === product.id
                        ? theme.palette.primary.contrastText
                        : theme.palette.text.secondary,
                    maxWidth: isMobile ? "none" : "150px",
                    flex: isMobile ? 1 : undefined,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {isMobile
                    ? product.nombre
                    : product.nombre?.length > 24
                      ? `${product.nombre.slice(0, 24)}...`
                      : product.nombre}
                </span>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginRight: ".5em",
                }}
              >
                {/* Editar */}
                <IconButton
                  size="small"
                  aria-label="edit-product"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditProductClick(product);
                  }}
                  sx={{
                    color:
                      selectedProductId === product.id ? "#fff" : "#90b2b7",
                    border: "1.5px solid",
                    marginLeft: ".2em",
                    padding: "2.5px",
                  }}
                >
                  <Tooltip title="Editar Diseño">
                    <DesignServicesOutlinedIcon fontSize="inherit" />
                  </Tooltip>
                </IconButton>

                {canEnrollNml && (
                  <IconButton
                    size="small"
                    aria-label="enroll-nml-cp"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setNmlEnrollProduct(product);
                    }}
                    sx={{
                      color:
                        selectedProductId === product.id ? "#fff" : "#90b2b7",
                      border: "1.5px solid",
                      marginLeft: ".2em",
                      padding: "2.5px",
                    }}
                  >
                    <Tooltip title={t("NmlSuzhou.enrollFromTree")}>
                      <ViewWeekOutlinedIcon fontSize="inherit" />
                    </Tooltip>
                  </IconButton>
                )}

                {/* Añadir muestra */}
                <IconButton
                  size="small"
                  aria-label="add-muestra"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddMuestraClick(product);
                  }}
                  sx={{
                    color:
                      selectedProductId === product.id ? "#fff" : "#90b2b7",
                    border: "1.5px solid",
                    marginLeft: ".2em",
                    padding: "2.5px",
                  }}
                >
                  <Tooltip title="Añadir Muestra">
                    <AddIcon fontSize="inherit" />
                  </Tooltip>
                </IconButton>

                {/* Eliminar diseño (solo si se puede) */}
                {canDelete && (
                  <IconButton
                    size="small"
                    aria-label="delete-product"
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteProduct(product);
                    }}
                    sx={{
                      border: "1.5px solid",
                      marginLeft: ".2em",
                      padding: "2.5px",
                    }}
                  >
                    <Tooltip title="Eliminar Diseño">
                      <DeleteOutlinedIcon fontSize="inherit" />
                    </Tooltip>
                  </IconButton>
                )}
              </Box>
            </Box>
          }
          collapsed={!expandedNodes.product?.[product.id]}
        >
          {renderSamples(productSamples[product.id], product.id)}
        </TreeView>
      );
    });
  };
  const renderSamples = (samples, productId) => {
    const searchValue = debouncedSearch?.trim().toLowerCase();
    const sampleMatchesSearch = (sample) => {
      if (!searchValue || searchValue.length < 3) return false;
      return (
        sample?.MUESTRA?.toLowerCase().includes(searchValue) ||
        sample?.NombreCliente?.toLowerCase().includes(searchValue)
      );
    };

    if (loadingSamples[productId]) {
      return (
        <Typography sx={{ marginLeft: "40px", fontStyle: "italic" }}>
          Cargando muestras...
        </Typography>
      );
    }

    if (!samples || samples.length === 0) {
      return (
        <Typography
          variant="body2"
          sx={{ marginLeft: "40px", color: "#606060" }}
        >
          No hay Muestras...
        </Typography>
      );
    }

    return samples.map((sample) => {
      const isSelected = Number(selectedSampleId) === Number(sample.ID_MUESTRA);
      const matchesSearch = sampleMatchesSearch(sample) && !isSelected;

      return (
        <TreeView
          key={`sample-${sample.ID_MUESTRA}`}
          nodeLabel={
            <Box
              onClick={(e) => {
                e.stopPropagation();
                setSelectedSampleId(sample.ID_MUESTRA);
                // Keep product selected when clicking a sample in the tree
                if (selectedProductId !== productId) {
                  const product = products.find((p) => p.id === productId);
                  if (product) {
                    setSelectedProduct(product);
                    setSelectedProductId(product.id);
                  }
                }
                if (isMobile) setMobileDetailView(true);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: ".8em",
                color: isSelected
                  ? "#ffffff"
                  : matchesSearch
                    ? theme.palette.primary.main
                    : "#FFAC7E",
                fontWeight: 700,
                paddingBottom: ".3em",
                backgroundColor: isSelected
                  ? theme.palette.primary.main
                  : "transparent",
                borderRadius: "4px",
                px: isSelected ? 0.8 : 0,
                py: isSelected ? 0.3 : 0,
                width: "fit-content",
                cursor: "pointer",
                textDecoration: matchesSearch ? "underline" : "none",
                textUnderlineOffset: "2px",
              }}
            >
              <DryCleaningOutlinedIcon sx={{ marginRight: ".3em" }} />
              {sample.MUESTRA}
              {sample.NombreCliente ? ` - ${sample.NombreCliente}` : ""}
            </Box>
          }
        />
      );
    });
  };
  useEffect(() => {
    if (!debouncedSearch) return;
    const { newExpanded } = filterProducts(products);
    setExpandedNodes((prev) => ({ ...prev, ...newExpanded }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  // REFRESH LOCAL MUESTRA DESDE FILE UPLOADER (SIN HACER FETCH GENERAL)
  const updateMuestraLocally = (updatedMuestra) => {
    const productId = updatedMuestra.ID_PRODUCTO;

    // 1. productSamples
    setProductSamples((prev) => ({
      ...prev,
      [productId]: (prev[productId] || []).map((m) =>
        m.ID_MUESTRA === updatedMuestra.ID_MUESTRA ? updatedMuestra : m,
      ),
    }));

    // 2. products[].muestras (por coherencia)
    setProducts((prev) =>
      prev.map((p) =>
        p.id === productId
          ? {
              ...p,
              muestras: p.muestras?.map((m) =>
                m.ID_MUESTRA === updatedMuestra.ID_MUESTRA ? updatedMuestra : m,
              ),
            }
          : p,
      ),
    );
  };

  const { filtered } = useMemo(
    () => filterProducts(products),
    [products, debouncedSearch],
  );

  // Auto-selecciona el primer resultado para abrir FileUploader al buscar
  useEffect(() => {
    const hasSearch = debouncedSearch.trim().length >= 3;
    if (!hasSearch) {
      if (
        Number.isFinite(requestedProductId) &&
        Number.isFinite(requestedMuestraId)
      ) {
        return;
      }
      setSelectedProduct(null);
      setSelectedProductId(null);
      return;
    }

    if (!filtered.length) {
      setSelectedProduct(null);
      setSelectedProductId(null);
      return;
    }

    const firstMatch = filtered[0];
    setSelectedProduct(firstMatch);
    setSelectedProductId(firstMatch.id);
  }, [debouncedSearch, filtered, requestedMuestraId, requestedProductId]);

  if (!hasProductTreeAccess) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ...contentMargin,
        px: { xs: 1.25, sm: 2 },
        pt: { xs: 0.5, md: 1 },
        pr: { xs: 1.25, sm: 2, md: 3 },
        pb: { xs: 10, md: 2 },
        boxSizing: "border-box",
        height: { xs: "100dvh", md: "100vh" },
        minHeight: { xs: "100dvh", md: "auto" },
        maxHeight: { md: "100dvh" },
        overflow: "hidden",
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          gap: 2,
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          overflow: { xs: mobileDetailView ? "auto" : "hidden", md: "hidden" },
        }}
      >
        {(!isMobile || !mobileDetailView) && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", md: "21em" },
              minWidth: { xs: 0, md: "21em" },
              flex: { xs: 1, md: "0 0 auto" },
              height: { md: "100%" },
              minHeight: { xs: 0, md: 0 },
              maxHeight: { xs: mobileDetailView ? 0 : "none", md: "none" },
              overflow: "hidden",
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                px: { xs: 1.5, sm: 2 },
                py: 1,
                mb: 2,
                minHeight: 72,
                display: "flex",
                alignItems: "center",
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                background:
                  "linear-gradient(135deg, rgba(0,188,212,0.12) 0%, rgba(103,58,183,0.12) 100%)",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                  width: "100%",
                }}
              >
                <TextField
                  size="small"
                  label="Buscar"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  sx={{
                    flex: "1 1 10em",
                    minWidth: 0,
                    alignSelf: "center",
                    "& .MuiInputBase-root": {
                      backgroundColor: theme.palette.caja.main,
                      color: theme.palette.text.primary,
                      borderRadius: 2,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.divider,
                    },
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.secondary,
                    },
                    "& .MuiInputBase-input": {
                      color: theme.palette.text.primary,
                    },
                  }}
                  placeholder="Buscar por nombre, nombre Cliente, tipo, material, diseñador, temporada..."
                />

                <Tooltip title="Crear Nuevo Diseño">
                  <IconButton
                    aria-label="add"
                    color="primary"
                    onClick={handleAddProductClick}
                    size="small"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                      bgcolor: theme.palette.background.paper,
                      "&:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Abrir NAS">
                  <IconButton
                    aria-label="nas"
                    color="primary"
                    onClick={toggleFileManager}
                    size="small"
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                      bgcolor: theme.palette.background.paper,
                      "&:hover": {
                        bgcolor: alpha(theme.palette.secondary.main, 0.15),
                        borderColor: theme.palette.secondary.main,
                      },
                    }}
                  >
                    <FolderOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                minHeight: 0,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
                p: 0.75,
                backgroundColor: theme.palette.background.paper,
                boxShadow:
                  theme.palette.mode === "dark"
                    ? "0 4px 20px rgba(0,0,0,0.35)"
                    : "0 6px 24px rgba(0,0,0,0.06)",
              }}
            >
              {renderTreeItems()}
            </Box>
            {isMobile && !selectedProduct ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  flexShrink: 0,
                  textAlign: "center",
                  py: 1,
                  px: 1,
                }}
              >
                Toca un diseño para ver archivos y muestras
              </Typography>
            ) : null}
          </Box>
        )}
        {selectedProduct && (!isMobile || mobileDetailView) ? (
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              minHeight: { xs: "auto", md: 0 },
              height: { md: "100%" },
            }}
          >
            {isMobile ? (
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => setMobileDetailView(false)}
                sx={{
                  alignSelf: "flex-start",
                  mb: 1,
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: 2,
                }}
              >
                Volver al árbol
              </Button>
            ) : null}
            <FileUploader
              key={selectedProductId}
              productId={selectedProduct?.id}
              productName={selectedProduct?.nombre}
              muestras={productSamples[selectedProduct?.id] || []}
              temporada={
                temporadas.find(
                  (temp) => temp.ID_TEMPORADA === selectedProduct.ID_Temporadas,
                )?.TEMPORADA || ""
              }
              marca={
                marcas.find((m) => m.ID_MARCA === selectedProduct.ID_MARCA)
                  ?.MARCA || ""
              }
              designer={getDesignerName(selectedProduct.diseñador)}
              selectedSampleId={selectedSampleId}
              onSelectSample={setSelectedSampleId}
              onRefresh={refreshData}
              onDeleteMuestra={(id) =>
                handleDeleteMuestraFromTree(id, selectedProduct?.id)
              }
              onMuestraUpdated={updateMuestraLocally}
              userCanCreateSample={userCanCreateSample}
              onFilesStatusChange={handleFilesStatusChange}
            />
          </Box>
        ) : null}
      </Box>
      {/* Drawer NAS */}
      <Box>
        <Drawer
          anchor="right"
          open={fileManagerOpen}
          onClose={toggleFileManager}
          PaperProps={{
            sx: {
              width: { xs: "100%", sm: 480 },
              maxWidth: "100vw",
              boxSizing: "border-box",
            },
          }}
        >
          <NASFileManager initialPath="" onClose={toggleFileManager} />
        </Drawer>
      </Box>
      {/* Drawer AÑADIR PRODUCTO */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 400 },
            maxWidth: "100vw",
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          sx={{ width: "100%", maxWidth: 400, p: 2, boxSizing: "border-box" }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 800,
              p: 1.5,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              background:
                "linear-gradient(135deg, rgba(0,188,212,0.14) 0%, rgba(103,58,183,0.12) 100%)",
            }}
          >
            Añadir Nuevo Producto
          </Typography>
          {/* MARCA */}
          <FormControl fullWidth sx={{ mb: 1, mt: 3 }}>
            <InputLabel>Marca</InputLabel>
            <Select
              label="Marca"
              value={newProduct.ID_MARCA}
              onChange={(e) =>
                setNewProduct({ ...newProduct, ID_MARCA: e.target.value })
              }
              fullWidth
            >
              {marcas.map((marca) => (
                <MenuItem key={marca.ID_MARCA} value={marca.ID_MARCA}>
                  {marca.MARCA}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* TEMORADA */}
          <FormControl fullWidth sx={{ /*  mb: 1, */ mt: 1 }}>
            <InputLabel>Temporada</InputLabel>
            <Select
              label="Temporada"
              value={newProduct.ID_Temporada}
              onChange={(e) =>
                setNewProduct({ ...newProduct, ID_Temporada: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
            >
              {temporadas.map((temporada) => (
                <MenuItem
                  key={temporada.ID_TEMPORADA}
                  value={temporada.ID_TEMPORADA}
                >
                  {temporada.TEMPORADA} ({temporada.ABREVIATURA})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* TIPO DE PRENDA */}
          <FormControl fullWidth>
            <InputLabel>Tipo de Prenda</InputLabel>
            <Select
              label="Tipo de Prenda"
              value={newProduct.tipo_prenda}
              onChange={(e) =>
                setNewProduct({ ...newProduct, tipo_prenda: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
            >
              {modelosTipo.map((tipo) => (
                <MenuItem key={tipo.ID_TIPO} value={tipo.ID_TIPO}>
                  {tipo.TIPO} ({tipo.ABREVIATURA})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* MAIN FABRIC */}
          <FormControl fullWidth>
            <InputLabel>Main Fabric</InputLabel>
            <Select
              label="Main Fabric"
              value={newProduct.ID_SUBGRUPO}
              onChange={(e) =>
                setNewProduct({ ...newProduct, ID_SUBGRUPO: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
            >
              {subgrupos.map((subgrupo) => (
                <MenuItem
                  key={subgrupo.ID_SUBGRUPO}
                  value={subgrupo.ID_SUBGRUPO}
                >
                  {subgrupo.SUBGRUPO}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* DISEÑADOR */}
          <FormControl fullWidth sx={{ mb: 1 }}>
            <InputLabel>Diseñador</InputLabel>
            <Select
              label="Diseñador"
              value={newProduct.diseñador}
              onChange={(e) =>
                setNewProduct({ ...newProduct, diseñador: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
            >
              {designers.map((designer) => (
                <MenuItem key={designer.id} value={designer.id}>
                  {designer.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* NOMBRE */}
          <FormControl fullWidth>
            <TextField
              label="Nombre"
              value={newProduct.nombre}
              onChange={(e) =>
                setNewProduct({ ...newProduct, nombre: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
              placeholder="Nombre generado automáticamente"
            />
          </FormControl>
          {/* NOMBRE CLIENTE */}
          {/*  <FormControl fullWidth>
            <InputLabel>Nombre del Cliente</InputLabel>
            <TextField
              label="Nombre Cliente"
              value={newProduct.nombreCliente}
              onChange={(e) =>
                setNewProduct({ ...newProduct, nombreCliente: e.target.value })
              }
              fullWidth
              sx={{ mb: 2 }}
            ></TextField>
          </FormControl> */}
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProduct}
            sx={{ width: "100%", py: 1.5, fontWeight: 700, mt: 1 }}
          >
            Guardar
          </Button>
        </Box>
      </Drawer>
      {/* DRAWER MUESTRA */}

      {/* <DrawerMuestra */}
      {/* DRAWER PARA CREAR / EDITAR MUESTRAS */}
      <DrawerMuestraV2
        open={muestraDrawerOpen}
        onClose={() => {
          setMuestraDrawerOpen(false);
          setEscandallos([]);
        }}
        onRefresh={refreshData}
        newMuestra={newMuestra}
        setNewMuestra={setNewMuestra}
        isEditMode={!!newMuestra?.ID_MUESTRA}
        isFromTree={true}
        selectedProduct={selectedProduct}
        tiposMuestra={tiposMuestra}
        tiposEstado={tiposEstado}
        tiposTallas={tiposTallas}
        tiposColores={tiposColores}
        tiposProveedores={tiposProveedores}
        tiposMarcas={marcas}
        escandalloGrupos={escandalloGrupos}
        escandalloSubgrupos={escandalloSubgrupos}
        setEscandallos={setEscandallos}
        handleSaveMuestra={handleSaveMuestra}
        handleAddMuestraLocally={handleAddMuestraLocally}
        userCanCreateSample={userCanCreateSample}
        /** 👇👇 NUEVO → sincroniza la eliminación */
        onDeleteMuestra={(id) =>
          handleDeleteMuestraFromTree(id, selectedProduct?.id)
        }
        onMuestraUpdated={updateMuestraLocally}
      />

      <NmlEnrollDialog
        open={Boolean(nmlEnrollProduct)}
        product={nmlEnrollProduct}
        permissions={currentUser}
        onClose={() => setNmlEnrollProduct(null)}
      />

      <Dialog
        open={openNombreDuplicadoDialog}
        onClose={() => setOpenNombreDuplicadoDialog(false)}
      >
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Nombre duplicado
          </Typography>
          <Typography variant="body1">
            Ya existe un producto con este nombre. Por favor elige otro nombre.
          </Typography>
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenNombreDuplicadoDialog(false)}
            >
              Entendido
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* DIALOGO CONFIRMAR ELIMINACIÓN DE DISEÑO */}
      <Dialog open={openDeleteProductDialog} onClose={cancelDeleteProduct}>
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Eliminar diseño
          </Typography>
          <Typography variant="body1">
            ¿Seguro que quieres eliminar el diseño{" "}
            <strong>{productToDelete?.nombre}</strong>? Esta acción no se puede
            deshacer.
          </Typography>
          <Box
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}
          >
            <Button variant="outlined" onClick={cancelDeleteProduct}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={confirmDeleteProduct}
            >
              Eliminar
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};
export default ProductTree;
